<template>
  <b-card class="p-3 mb-4">
    <b-card-title class="font-weight-bold mb-3">Comments</b-card-title>

    <!-- Add comment field -->
    <div class="d-flex mb-4">
      <div class="mt-1 mr-3">
        <b-avatar></b-avatar>
      </div>

      <b-form-input
        id="input-1"
        v-model="form.body"
        type="text"
        required
        placeholder="Add a comment"
        class="w-100 mr-3"
      ></b-form-input>

      <b-button class="post-btn" type="button" variant="primary" @click="submit"
        >Post</b-button
      >
    </div>

    <b-modal v-model="show" title="Delete Comment?" centered class="p-3">
      <p>Are you sure you want to permanently delete this comment?</p>
      <hr class="modal-divider" />
      <template v-slot:modal-footer>
        <b-button class="btn btn-secondary" @click="show = false"
          >Cancel</b-button
        >
        <b-button variant="primary" :disabled="loading" @click="removeComment">
          <b-spinner small v-if="loading"></b-spinner>Delete
        </b-button>
      </template>
    </b-modal>

    <b-card-text>
      <!-- Comments list -->
      <b-card no-body v-for="(comment, cIndex) in comments" :key="comment.id">
        <div class="d-flex w-100">
          <div class="mr-3">
            <b-avatar
              :src="
                comment.author && comment.author.avatar
                  ? comment.author.avatar.url
                  : ''
              "
            ></b-avatar>
          </div>

          <div class="w-100">
            <div class="options-btn">
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none p-0 h-auto"
                menu-class="option-list"
                no-caret
                dropleft
              >
                <template v-slot:button-content>
                  <b-icon
                    scale="1.2"
                    variant="secondary"
                    icon="three-dots-vertical"
                  ></b-icon>
                </template>

                <!-- <b-dropdown-item
                  v-if="comment.author_id === user.id"
                  @click="onClickEditComment(comment.id, comment.body)"
                  >Edit Comment</b-dropdown-item
                >-->

                <b-dropdown-item disabled v-if="comment.author_id === user.id"
                  >Edit Comment</b-dropdown-item
                >

                <b-dropdown-item
                  v-if="comment.author_id === user.id"
                  @click="onClickDeleteComment(comment.id)"
                  >Delete Comment</b-dropdown-item
                >

                <b-dropdown-item disabled v-if="comment.author_id !== user.id"
                  >Report Comment</b-dropdown-item
                >
              </b-dropdown>
            </div>

            <div class="font-weight-bold">
              {{ comment.author ? comment.author.full_name : '' }}
            </div>
            <div class="small">{{ comment.addedDate }}</div>
            <div class="my-2">{{ comment.body }}</div>
            <div class="d-flex w-100 mb-3">
              <b-link class="mr-5" @click="onClickReply(cIndex)">Reply</b-link>
            </div>
            <hr class="my-3" v-show="!comment._isReplying" />

            <!-- Add reply field -->
            <div v-show="comment._isReplying">
              <div class="d-flex mb-4">
                <div class="mt-1 mr-2">
                  <b-avatar
                    :src="user.avatar ? user.avatar.url : ''"
                  ></b-avatar>
                </div>

                <b-form-input
                  :id="`reply-${cIndex}`"
                  v-model="formReply.body"
                  type="text"
                  required
                  placeholder="Add a comment"
                  class="mr-2"
                ></b-form-input>

                <b-button
                  type="button"
                  variant="primary"
                  @click="submitReply(cIndex)"
                  >Post</b-button
                >
              </div>

              <!-- Replies List -->
              <b-card
                no-body
                v-for="(reply, rIndex) in comment._replies"
                :key="reply.id"
              >
                <div class="d-flex w-100">
                  <div class="mr-3">
                    <b-avatar
                      :src="
                        reply.author && reply.author.avatar
                          ? reply.author.avatar.url
                          : ''
                      "
                    ></b-avatar>
                  </div>

                  <div class="w-100">
                    <div class="font-weight-bold">
                      {{ reply.author ? reply.author.full_name : '' }}
                    </div>
                    <div class="small">{{ reply.addedDate }}</div>
                    <div class="my-2">{{ reply.body }}</div>
                    <hr
                      class="my-3"
                      v-if="rIndex !== comment._replies.length - 1"
                    />
                  </div>
                </div>
              </b-card>

              <hr class="my-3" v-if="cIndex !== comments.length - 1" />
            </div>
          </div>
        </div>
      </b-card>
    </b-card-text>
  </b-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState({
      comments: state => state.comment.list,
      user: state => state.auth.user
    })
  },

  data() {
    return {
      loading: false,
      show: false,
      editing: false,
      current: 0,
      formReply: {
        id: null,
        body: null
      },
      form: {
        id: null,
        job_id: this.$route.params.id,
        body: null
      }
    }
  },

  methods: {
    ...mapActions({
      getComments: 'comment/getComments',
      createComment: 'comment/createComment',
      createReply: 'comment/createReply',
      deleteComment: 'comment/deleteComment',
      updateComment: 'comment/updateComment'
    }),

    ...mapMutations({
      clearComments: 'comment/clearCommentList'
    }),

    onClickReply(index) {
      this.comments[index]._isReplying = !this.comments[index]._isReplying
      this.fetchReplies(index)
    },

    onClickDeleteComment(id) {
      this.show = true
      this.current = id
    },

    // onClickEditComment(id, body) {
    //   this.editing = true
    //   this.form.id = id
    //   this.form.body = body
    // },

    async fetchReplies(index, page = 1) {
      await this.$api
        .get(`comments/${this.comments[index].id}/responses?include[]=author`)
        .then(({ data }) => {
          this.comments[index]._replies = data.data
          this.comments[index]._repliesMeta = data.meta
        })
    },

    async submit() {
      // if (this.editing) {
      //   await this.updateComment(this.form)
      //   this.editing = false
      //   this.form.id = null
      // } else {
      await this.createComment(this.form)
      // }
      this.form.body = null
    },

    async submitReply(index) {
      this.formReply.id = this.comments[index].id
      await this.$api
        .post(`comments/${this.formReply.id}/responses`, this.formReply)
        .then(({ data }) => {
          this.comments[index]._replies.unshift(data.data)
          this.formReply.id = null
          this.formReply.body = null
        })
    },

    async removeComment() {
      this.loading = true
      await this.deleteComment(this.current)
      this.loading = false
      this.show = false
    }
  },

  created() {
    this.clearComments()
    this.getComments({ job_id: this.$route.params.id })
  }
}
</script>

<style scoped lang="scss">
.post-btn {
  height: 50px;
}
.options-btn {
  cursor: pointer;
  position: absolute;
  right: 5px;
  margin-top: 4px;
}
</style>
